import React, { useEffect, useState, useRef } from "react";
import {
  ButtonBase,
  DataTableBase,
  ModalBase,
  NavigationPageHeading,
} from "@reusejs/react";
import { useRouter } from "next/router";
import {
  getBidderForEvent,
  addBidderForEvent,
  deleteBidderForEvent,
  updateBidderForEvent,
  getBranchTeam,
  getAllMembersOfATeam,
  getAuctionEventByUuid,
} from "services";
import AddBidderModal from "../banker/bidders/addBidder";
import { XIcon, PencilIcon, EyeIcon } from "@heroicons/react/solid";
import ConfirmationModal from "../banker/bidders/confirmationModal";
import { DateTime } from "luxon";
import { AddJointBiddersModal } from "./AddJointBiddersModal";
import JBCountModal from "./JBCountModal";
import { getBidderParticipation } from "services/bidder";

export default function ViewBiddersAdmin() {
  const router = useRouter();
  const for_event = router.query.primary_identifier;
  const [event, setEvent] = useState<any>([]);
  const [membersEmail, setMembersEmail] = useState<any>([]);
  const tableRef = useRef<any>(null);
  const [showJBCountModal, setShowJBCountModal] = useState(false);
  const [jointBidderCount, setJointBidderCount] = useState(0);
  const [config, setConfig] = useState<any>({
    filterable: false,
    columns: [
      {
        label: "Email",
        identifier: "email",
        resolver: (d: any) => {
          return d.email;
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "KYC Verified",
        identifier: "kyc_verified",
        resolver: (d: any) => {
          return d.kyc_verified ? "Yes" : "No";
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "Emd Amount Paid",
        identifier: "emd_amount_paid",
        resolver: (d: any) => {
          return d.emd_amount_paid ? "Yes" : "No";
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "Agreement Signed",
        identifier: "agreement_signed",
        resolver: (d: any) => {
          return d.agreement_signed ? "Yes" : "No";
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "Application Form Filled",
        identifier: "application_form_filled",
        resolver: (d: any) => {
          return d.application_form_filled ? "Yes" : "No";
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "Status",
        identifier: "status",
        resolver: (d: any) => {
          return d.status;
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "",
        filterable: {
          type: "clear",
        },
        actions: true,
        resolver: (d: any) => {
          return (
            <div className="flex justify-center items-center space-x-2">
              {/* <div>
                <EyeIcon
                  className="flex-shrink-0 h-4 w-4 text-green-500 hover:text-green-700 cursor-pointer"
                  aria-hidden="true"
                  onClick={() =>
                    router.push(
                      `/dashboard/bidders/${d.uuid}?for_event=${for_event}`
                    )
                  }
                />
              </div> */}
              <div>
                <PencilIcon
                  className="flex-shrink-0 h-4 w-4 text-yellow-500 hover:text-yellow-700 cursor-pointer"
                  aria-hidden="true"
                  onClick={() =>
                    openModal(
                      "Update Bidder",
                      "",
                      "bg-blue-50 text-blue-500",
                      "edit",
                      d
                    )
                  }
                />
              </div>
              <div>
                <XIcon
                  className="flex-shrink-0 h-4 w-4 text-red-400 hover:text-red-600 cursor-pointer"
                  aria-hidden="true"
                  onClick={() => {
                    openDeletionConfirmationModal(
                      "Delete Bidder",
                      d?.is_joint
                        ? "The selected bidder is part of a joint participation. Deleting this bidder will also remove all associated joint bidders. Do you want to proceed?"
                        : "Are you sure you want to remove bidder?",
                      "bg-red-50 text-red-500",
                      d.uuid,
                      d
                    );
                  }}
                />
              </div>
            </div>
          );
        },
      },
    ],
  });
  const [configE, setConfigE] = useState<any>({
    filterable: false,
    columns: [
      {
        label: "Email",
        identifier: "email",
        resolver: (d: any) => {
          return d.email;
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "KYC Verified",
        identifier: "kyc_verified",
        resolver: (d: any) => {
          return d.kyc_verified ? "Yes" : "No";
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "Emd Amount Paid",
        identifier: "emd_amount_paid",
        resolver: (d: any) => {
          return d.emd_amount_paid ? "Yes" : "No";
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "Agreement Signed",
        identifier: "agreement_signed",
        resolver: (d: any) => {
          return d.agreement_signed ? "Yes" : "No";
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "Application Form Filled",
        identifier: "application_form_filled",
        resolver: (d: any) => {
          return d.application_form_filled ? "Yes" : "No";
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "Status",
        identifier: "status",
        resolver: (d: any) => {
          return d.status;
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "",
        filterable: {
          type: "clear",
        },
        actions: true,
        resolver: (d: any) => {
          return (
            <div className="flex justify-center items-center space-x-2">
              {/* <div>
                  <ButtonBase
                    variant="primary"
                    type="button"
                    label="View"
                    onClick={() =>
                      router.push(
                        `/dashboard/bidders/${d.uuid}?for_event=${for_event}`
                      )
                    }
                    buttonBaseClasses={{
                      font: "text-sm font-medium",
                      backgroundColor: "bg-blue-600 hover:bg-blue-700",
                      textColor: "text-white",
                      border: "any",
                      padding: "px-2 py-2",
                    }}
                  />
                </div> */}
            </div>
          );
        },
      },
    ],
  });
  const [configL, setConfigL] = useState<any>({
    filterable: false,
    columns: [
      {
        label: "Email",
        identifier: "email",
        resolver: (d: any) => {
          return d.email;
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "KYC Verified",
        identifier: "kyc_verified",
        resolver: (d: any) => {
          return d.kyc_verified ? "Yes" : "No";
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "Emd Amount Paid",
        identifier: "emd_amount_paid",
        resolver: (d: any) => {
          return d.emd_amount_paid ? "Yes" : "No";
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "Agreement Signed",
        identifier: "agreement_signed",
        resolver: (d: any) => {
          return d.agreement_signed ? "Yes" : "No";
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "Application Form Filled",
        identifier: "application_form_filled",
        resolver: (d: any) => {
          return d.application_form_filled ? "Yes" : "No";
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "Status",
        identifier: "status",
        resolver: (d: any) => {
          return d.status;
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "",
        filterable: {
          type: "clear",
        },
        actions: true,
        resolver: (d: any) => {
          return (
            <div className="flex justify-center items-center space-x-2">
              <div>
                <XIcon
                  className="flex-shrink-0 h-4 w-4 text-red-400 hover:text-red-600 cursor-pointer"
                  aria-hidden="true"
                  onClick={() => {
                    openDeletionConfirmationModal(
                      "Delete Bidder",
                      d?.is_joint
                        ? "The selected bidder is part of a joint participation. Deleting this bidder will also remove all associated joint bidders. Do you want to proceed?"
                        : "Are you sure you want to remove bidder?",
                      "bg-red-50 text-red-500",
                      d.uuid,
                      d
                    );
                  }}
                />
              </div>
            </div>
          );
        },
      },
    ],
  });

  const getTeamMembersEmail = async (event: any) => {
    const team: any = await getBranchTeam(event?.branch?.uuid);
    const teamData: any = team.data[0];
    let response: any = await getAllMembersOfATeam(teamData?.uuid);
    const filteredData = response.data
      .map((item: any) => {
        const emailAttr = item?.attributes?.find(
          (attr: any) => attr.type === "email"
        );
        return emailAttr ? emailAttr.value : null;
      })
      .filter(Boolean);
    setMembersEmail(filteredData);
  };

  const handleJointBidderSelect = async (bidderCount: number) => {
    setJointBidderCount(bidderCount);
    setShowJBCountModal(false);
  };

  const handleJointBidderCancel = () => {
    setShowJBCountModal(false);
  };

  useEffect(() => {
    if (for_event) {
      (async () => {
        await init(for_event);
      })();
    }
  }, [for_event]);

  const init = async (id: any) => {
    const data: any = await getAuctionEventByUuid(id);
    setEvent(data);
  };

  useEffect(() => {
    if (tableRef && tableRef.current) {
      tableRef?.current?.refresh();
    }
    if (event) {
      getTeamMembersEmail(event);
    }
  }, [event]);

  const dataSource = async (params: any) => {
    let response: any = {};

    if (params) {
      params["filterBy"] = {
        attribute: "access_type",
        op: "eq",
        value: "primary",
      };
    }

    if (event?.uuid) {
      response = await getBidderForEvent(params, event?.uuid);
    } else {
      response = { data: [], meta: { total: 0 } };
    }

    let data = response.data;

    return {
      data: data,
      pagination: {
        total: response.meta.total,
      },
    };
  };

  const openModal = async (
    title: string,
    message: string,
    color: string,
    type: string,
    data: any
  ) => {
    const AddModalWrapper = (props: any) => {
      return (
        <AddBidderModal
          router={router}
          heading={title}
          type={type}
          description={message}
          prefillData={data}
          excludeEmails={membersEmail}
          callback={async (form: any, formValue: any) =>
            type === "create"
              ? await handleAddBidder(form, formValue)
              : await hanldeUpdateBidder(form, formValue, data)
          }
          color={color}
          {...props}
        />
      );
    };

    const AddJointModalWrapper = (props: any) => {
      return (
        <AddJointBiddersModal
          router={router}
          biddersCount={jointBidderCount}
          {...props}
        />
      );
    };

    await ModalBase(
      {
        content:
          title === "Add Joint Bidder" ? AddJointModalWrapper : AddModalWrapper,
        timeout: 0,
        backgroundColor: "bg-black/30",
        backgroundOpacity: "opacity-70",
        modalBaseClasses: {
          background: "bg-white",
          border: "border-2 rounded-lg",
          alignment: "text-left overflow-visible",
          padding: "p-0",
          small: "sm:my-8 sm:w-full sm:max-w-md",
        },
      },
      1000,
      "__next"
    );
  };

  const handleAddBidder = async (form: any, data: any) => {
    try {
      let payload = data;
      payload["event_uuid"] = event?.uuid;

      if (payload.initial_bid_price) {
        payload["initial_bid_price"] = Number(payload.initial_bid_price);
      }

      if (
        payload.kyc_verified &&
        payload.emd_amount_paid &&
        payload.agreement_signed &&
        payload.application_form_filled
      ) {
        payload["status"] = "verified";
      } else {
        payload["status"] = "pending";
      }

      const eventData: any = await getAuctionEventByUuid(for_event);

      payload["meta"] = {
        user_details: { mobile_number: payload?.mobile_number },
        banker_email: eventData?.meta?.assigned_ao?.email, //banker?.attributes[0]?.value,
        bank_name: eventData?.bank?.name,
        approver_email:
          eventData?.meta?.approver && eventData?.meta?.approver.length > 0
            ? eventData?.meta?.approver[0]?.email
            : "",
        approver_name:
          eventData?.meta?.approver && eventData?.meta?.approver.length > 0
            ? eventData?.meta?.approver[0]?.name
              ? eventData?.meta?.approver[0]?.name
              : eventData?.meta?.approver[0]?.email
            : "",
        branch_name: eventData?.branch?.name,
        event_name: eventData?.event_name,
        dashboard_url: `${process.env.NEXT_PUBLIC_BIDDER_DB_URL}/auction-events`,
        event_id: eventData.listing_id,
        auction_start_datetime: DateTime.fromISO(eventData?.start_date_time)
          .setZone("Asia/Kolkata")
          .toFormat("dd MMMM yyyy hh:mm a"),
        emd_last_datetime: DateTime.fromISO(
          eventData?.property_dump?.emd_last_date
        )
          .setZone("Asia/Kolkata")
          .toFormat("dd MMMM yyyy hh:mm a"),
        name: payload.name,
        pan: payload.pan,
        ...(payload.initial_bid_price && payload.initial_bid_price > 0
          ? { initial_bid_price: payload.initial_bid_price }
          : {}),
      };

      const res = await addBidderForEvent(payload);
      if (res) {
        if (tableRef && tableRef.current) {
          tableRef?.current?.refresh();
        }
      }
      return true;
    } catch (error: any) {
      console.log("error", error);
      if (error?.response?.data?.errors) {
        form.setErrors(error.response.data.errors);
      }

      if (error?.response?.data?.message?.errorDetails) {
        let emailError = error?.response?.data?.message?.errorDetails?.email;
        let mobileError = error?.response?.data?.message?.errorDetails?.mobile;

        if (emailError && mobileError)
          form.setErrors({
            email: [emailError],
            mobile_number: [mobileError],
          });
        else if (emailError)
          form.setErrors({
            email: [emailError],
          });
        else if (mobileError)
          form.setErrors({
            mobile_number: [mobileError],
          });
      }
      return false;
    }
  };

  const hanldeUpdateBidder = async (form: any, payload: any, data: any) => {
    try {
      console.log("check here::>", data);
      payload["uuid"] = data.uuid;
      if (
        payload.kyc_verified &&
        payload.emd_amount_paid &&
        payload.agreement_signed &&
        payload.application_form_filled
      ) {
        payload["status"] = "verified";
      } else {
        payload["status"] = "pending";
      }

      const eventData: any = await getAuctionEventByUuid(data.event_uuid);
      console.log("event::1234::>", eventData, for_event);
      payload["meta"] = {
        user_details: { mobile_number: payload?.mobile_number },
        banker_email: eventData?.meta?.assigned_ao?.email,
        bank_name: eventData?.bank?.name,
        approver_email:
          eventData?.meta?.approver && eventData?.meta?.approver.length > 0
            ? eventData?.meta?.approver[0]?.email
            : "",
        approver_name:
          eventData?.meta?.approver && eventData?.meta?.approver.length > 0
            ? eventData?.meta?.approver[0]?.name
              ? eventData?.meta?.approver[0]?.name
              : eventData?.meta?.approver[0]?.email
            : "",
        branch_name: eventData?.branch?.name,
        event_name: eventData?.event_name,
        dashboard_url: `${process.env.NEXT_PUBLIC_BIDDER_DB_URL}/auction-events`,
        event_id: eventData.listing_id,
        auction_start_datetime: DateTime.fromISO(eventData?.start_date_time)
          .setZone("Asia/Kolkata")
          .toFormat("dd MMMM yyyy hh:mm a"),
        emd_last_datetime: DateTime.fromISO(
          eventData?.property_dump?.emd_last_date
        )
          .setZone("Asia/Kolkata")
          .toFormat("dd MMMM yyyy hh:mm a"),
        name: payload.name,
        pan: payload.pan,
        ...(payload.initial_bid_price && payload.initial_bid_price > 0
          ? { initial_bid_price: payload.initial_bid_price }
          : {}),
      };
      const res = await updateBidderForEvent(payload);
      if (res) {
        if (tableRef && tableRef.current) {
          tableRef?.current?.refresh();
        }
      }
      return true;
    } catch (error: any) {
      console.log("error::", error);
      if (error?.response?.data?.errors) {
        form.setErrors(error.response.data.errors);
      }

      if (error?.response?.data?.message?.errorDetails) {
        let emailError = error?.response?.data?.message?.errorDetails?.email;
        let mobileError = error?.response?.data?.message?.errorDetails?.mobile;

        if (emailError && mobileError)
          form.setErrors({
            email: [emailError],
            mobile_number: [mobileError],
          });
        else if (emailError)
          form.setErrors({
            email: [emailError],
          });
        else if (mobileError)
          form.setErrors({
            mobile_number: [mobileError],
          });
      }
      return false;
    }
  };

  const handleDeleteBidder = async (uuid: string, bidder: any) => {
    try {
      const handleBidderDeleteWithJoints = async () => {
        try {
          if (bidder?.is_joint) {
            const res: any = await getBidderParticipation({
              bidder_uuid: bidder?.uuid,
            });
            console.log("res: ", res);
            if (res?.length > 0) {
              const res2: any = await getBidderParticipation({
                primary_bidder_uuid: res?.[0]?.primary_bidder_uuid,
              });
              if (res2?.length > 0) {
                for (let i = 0; i < res2.length; i++) {
                  const deleteBidderUuid = res2[i]?.bidder_uuid;
                  await deleteBidderForEvent(deleteBidderUuid);
                }
                if (tableRef && tableRef.current) {
                  tableRef?.current?.refresh();
                }
                await new Promise((r) => setTimeout(r, 2000));
              }
            } else {
              if (tableRef && tableRef.current) {
                tableRef?.current?.refresh();
              }
            }
          } else {
            const res = await deleteBidderForEvent(uuid);
            if (res) {
              if (tableRef && tableRef.current) {
                tableRef?.current?.refresh();
              }
            }
          }
        } catch (error) {
          console.error("Error while deleting bidder:", error);
        }
      };

      handleBidderDeleteWithJoints();
    } catch (error) {
      console.log("check here error", error);
    }
  };

  const openDeletionConfirmationModal = async (
    title: string,
    message: string,
    color: string,
    uuid: string,
    d?: any
  ) => {
    const ConfirmationModalWrapper = (props: any) => {
      return (
        <ConfirmationModal
          heading={title}
          description={message}
          callback={() => handleDeleteBidder(uuid, d)}
          color={color}
          {...props}
        />
      );
    };

    await ModalBase(
      {
        content: ConfirmationModalWrapper,
        timeout: 0,
        backgroundColor: "bg-black/30",
        backgroundOpacity: "opacity-70",
        modalBaseClasses: {
          background: "bg-white",
          border: "border-2 rounded-lg",
          alignment: "text-left overflow-visible",
          padding: "p-0",
          small: "sm:my-8 sm:w-full sm:max-w-md",
        },
      },
      1000,
      "__next"
    );
  };

  return (
    <>
      <NavigationPageHeading
        titleText={() => (
          <div className="mt-2 text-xl text-gray-700 dark:text-gray-200">
            Bidders
          </div>
        )}
        actions={() => {
          return (
            <div className="flex space-x-2">
              <ButtonBase
                type="button"
                label="Add Bidder"
                onClick={() =>
                  openModal(
                    "Add Bidder",
                    "",
                    "bg-blue-50 text-blue-500",
                    "create",
                    null
                  )
                }
                disabled={event && event.status === "end"}
              />
              {process.env.NEXT_PUBLIC_JBP_ENABLE === "true" && (
                <ButtonBase
                  type="button"
                  label="Add Joint Bidders"
                  onClick={() => {
                    setJointBidderCount(0);
                    setShowJBCountModal(true);
                  }}
                  disabled={event && event.status === "end"}
                />
              )}
            </div>
          );
        }}
        breadcrumbs={[]}
      />
      <div className="w-full p-6 flex flex-col justify-center">
        <div className="mt-10">
          <DataTableBase
            ref={tableRef}
            sortColumn={0}
            sortOrder={"asc"}
            dataSource={dataSource}
            perPage={10}
            config={
              event?.status === "end"
                ? configE
                : event?.status === "live"
                ? configL
                : config
            }
          />
        </div>
      </div>
      {jointBidderCount > 0 && (
        <AddJointBiddersModal
          setJointBidderCount={setJointBidderCount}
          router={router}
          biddersCount={jointBidderCount}
          onAction={handleJointBidderCancel}
          excludeEmails={membersEmail}
          eventId={for_event}
        />
      )}

      {showJBCountModal && (
        <JBCountModal
          onSubmit={handleJointBidderSelect}
          onCancel={handleJointBidderCancel}
          redirectUrl=""
        />
      )}
    </>
  );
}
